import { render, staticRenderFns } from "./EnquiryActionBox.vue?vue&type=template&id=fefe1a48&"
import script from "./EnquiryActionBox.vue?vue&type=script&lang=js&"
export * from "./EnquiryActionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions,QSpace} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions,QSpace})
